import React from 'react';
import PropTypes from 'prop-types';

export default class TitleBar extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    children: PropTypes.node,
  };
  static contextTypes = {
    setTitleBar: PropTypes.func,
  };

  componentWillMount() {
    const { title, subtitle, children } = this.props;
    this.context.setTitleBar({ title, subtitle, children });
  }

  // KW: removed children since this causes a crazy state update loop
  // I would guess it is due to inability to detect changes to children
  componentWillReceiveProps(nextProps) {
    const { title, subtitle } = this.props;
    if (title !== nextProps.title || subtitle !== nextProps.subtitle) {
      this.context.setTitleBar({
        title: nextProps.title,
        subtitle: nextProps.subtitle,
      });
    }
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Layout/StandardPageTemplate/Context/TitleBar.js